/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:9813d7d0-d601-4867-90c7-70ffd6aaf051",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_DZsFYDe8E",
    "aws_user_pools_web_client_id": "d9e1l63ckt7jafnccer65rpdt",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "portal-20220413012445-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://d3s5bay1355t75.cloudfront.net",
    "aws_mobile_analytics_app_id": "303e2f7c7b13490081e214cbbbba346a",
    "aws_mobile_analytics_app_region": "us-west-2"
};


export default awsmobile;
